// extracted by mini-css-extract-plugin
module.exports = {"spin":"spin--1rsQi","iconpark-spin":"iconpark-spin--1poVQ","rtl":"rtl--1k3ai","iconpark-spin-rtl":"iconpark-spin-rtl--2XweM"};